export default __webpack_public_path__ + "static/media/NewYearResolution_19.e7b238ce.png";